import { createFileRoute } from "@tanstack/react-router";
import { OverlapPage } from "@/features/tzoverlap/OverlapPage";

export const Route = createFileRoute("/_app/calendar/overlap")({
  component: OverlapPage,
});
